import { render, staticRenderFns } from "./year-range.vue?vue&type=template&id=fc0b7aaa&"
import script from "./year-range.vue?vue&type=script&lang=js&"
export * from "./year-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports